import type { MenuFormat } from "@velizhanin-dev/bot-scenario"
import { cn } from "@/shared/lib/utils"

const FORMATS: { value: MenuFormat; title: string; text: string }[] = [
	{
		value: "keyboard",
		title: "Клавиатура",
		text: "Крупные кнопки вместо клавиатуры телефона. Всегда под рукой, но занимают пол-экрана.",
	},
	{
		value: "inline",
		title: "Кнопки под сообщением",
		text: "Меню приходит сообщением, подменю открываются в нём же. Можно ставить ссылки. Меню приходит после каждой воронки и по команде /menu.",
	},
]

/** Схема чата: пузырь сообщения и кнопки там, где их покажет Telegram. */
function Sketch({ format }: { format: MenuFormat }) {
	const button = "h-3 rounded-[4px] bg-foreground/25"
	return (
		<div className="flex h-24 w-20 shrink-0 flex-col justify-end gap-1 rounded-xl border border-border bg-background p-1.5">
			<div className="h-4 w-12 rounded-md bg-foreground/15" />
			{format === "inline" ? (
				<div className="grid grid-cols-2 gap-0.5">
					<span className={button} />
					<span className={button} />
					<span className={cn(button, "col-span-2")} />
				</div>
			) : (
				<>
					<div className="mt-auto h-px bg-border" />
					<div className="grid grid-cols-2 gap-0.5 rounded-md bg-foreground/5 p-0.5">
						<span className={cn(button, "h-4")} />
						<span className={cn(button, "h-4")} />
						<span className={cn(button, "col-span-2 h-4")} />
					</div>
				</>
			)}
		</div>
	)
}

export function MenuFormatPicker({
	value,
	onChange,
}: {
	value: MenuFormat
	onChange: (value: MenuFormat) => void
}) {
	return (
		<div role="radiogroup" aria-label="Как выглядит меню" className="grid gap-3 sm:grid-cols-2">
			{FORMATS.map((format) => {
				const active = format.value === value
				return (
					<button
						key={format.value}
						type="button"
						role="radio"
						aria-checked={active}
						onClick={() => onChange(format.value)}
						className={cn(
							"flex gap-4 rounded-2xl border bg-card p-4 text-left transition-[border-color,box-shadow]",
							active
								? "border-primary/60 ring-4 ring-primary/10"
								: "border-border hover:border-foreground/20",
						)}
					>
						<Sketch format={format.value} />
						<span className="min-w-0">
							<span className="flex items-center gap-2 text-sm font-medium">
								<span
									aria-hidden
									className={cn(
										"grid size-4 place-items-center rounded-full border",
										active ? "border-primary" : "border-muted-foreground/50",
									)}
								>
									{active ? <span className="size-2 rounded-full bg-primary" /> : null}
								</span>
								{format.title}
							</span>
							<span className="mt-1.5 block text-xs leading-relaxed text-muted-foreground">
								{format.text}
							</span>
						</span>
					</button>
				)
			})}
		</div>
	)
}
